var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"timeout":-1,"value":_vm.value},on:{"input":_vm.input}},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }